module.exports = __webpack_public_path__ + "img/df3b48c.png";